import { Tooltip, Button } from "antd";
import { useTranslation } from "react-i18next";
// import { AiOutlineSync } from "react-icons/ai";
import { FaAutoprefixer } from "react-icons/fa";
import { useLogout } from "Components/Login/quires";
import { useIdleTimer } from "react-idle-timer";
import { Fragment, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useAppSelector } from "store/hook";
import { ReloadOutlined } from "@ant-design/icons";

const AutoRefresh = ({ queriesArray, extraFunc }: { queriesArray: string[]; extraFunc?: Function }) => {
  const { t } = useTranslation();
  const { stateCid } = useAppSelector((state) => state.global);
  const { getRemainingTime } = useIdleTimer({
    timeout: 300000,
  });
  const [count, setCount] = useState(0);
  const queryClient = useQueryClient();
  const { mutate: logoutMutatiion } = useLogout();
  const [AutoRefresh, setAutoRefresh] = useState(false);

  useEffect(() => {
    if (!AutoRefresh) {
      return;
    }

    const remainTime = getRemainingTime();
    if (remainTime === 0) {
      // logoutMutatiion(); FIXME: (關閉 autofresh 自動 logout?)
    }

    // queryClient.invalidateQueries(...queriesArray);
    queriesArray.forEach((query) => queryClient.invalidateQueries([query, stateCid]));
    // queryClient.invalidateQueries(["status", stateCid]);
    const stateInterval = setInterval(() => {
      setCount((prevState) => prevState + 1);
    }, 10000);
    return () => clearInterval(stateInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AutoRefresh === true, count]);
  return (
    <Tooltip title={t("ISMS.AutoRefresh")}>
      <Button
        style={{
          position: "relative",
          background: AutoRefresh ? "#64bce5" : "",
          color: AutoRefresh ? "gray" : "black",
        }}
        icon={
          <Fragment>
            <ReloadOutlined />
            <FaAutoprefixer
              style={{
                position: "absolute",
                top: "50%",
                bottom: "50%",
                right: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          </Fragment>
        }
        onClick={() => {
          setAutoRefresh(!AutoRefresh);
          if (extraFunc) {
            extraFunc();
          }
        }}
      ></Button>
    </Tooltip>
  );
};

export default AutoRefresh;
